import { BACKEND } from "../variables.js";
import axios from "axios";

const HISTORY = BACKEND + "/history/getHistory";
const HISTORY_BY_HOUSE = BACKEND + "/history/getHistoryByHouse";
const HISTORY_BY_ADMIN = BACKEND + "/history/getHistoryByAdmin";
const HISTORY_STATS = BACKEND + "/history/getStats";
const HISTORY_ACTIONS = BACKEND + "/history/getActionList";
const MY_HISTORY = BACKEND + "/history/getMyHistory";
const MY_HISTORY_STATS = BACKEND + "/history/getMyStats";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    LIST_ACTIVITIES(state, payload) {
      return axios({
        method: "POST",
        url: HISTORY,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    LIST_ACTIVITIES_BY_HOUSE(state, payload) {
      return axios({
        method: "POST",
        url: HISTORY_BY_HOUSE,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    LIST_ACTIVITIES_BY_ADMIN(state, payload) {
      return axios({
        method: "POST",
        url: HISTORY_BY_ADMIN,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    GET_ACTIVITY_STATS(state, payload) {
      return axios({
        method: "POST",
        url: HISTORY_STATS,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    GET_ACTIVITY_ACTION_LIST(state, payload) {
      return axios({
        method: "POST",
        url: HISTORY_ACTIONS,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    LIST_MY_ACTIVITIES(state, payload) {
      return axios({
        method: "POST",
        url: MY_HISTORY,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    GET_MY_ACTIVITY_STATS(state, payload) {
      return axios({
        method: "POST",
        url: MY_HISTORY_STATS,
        data: payload.data || {},
        headers: { Authorization: payload.token },
      });
    },
  },
};
